import useLocalStorageState from 'use-local-storage-state';
import { useNetworkInformation } from './useNetworkInformation';
import { useEffect } from 'react';
import { useUpdateHistoryBySessionIdMutation } from '../redux/api/historyApiSlice';

export const usePlayerHistoryState = ({ skip }: { skip?: boolean }) => {
  const [interruptedSession,,{ removeItem }] = useLocalStorageState<string>('interruptedSession');
  
  const isOnline = useNetworkInformation();
  const [mutation] = useUpdateHistoryBySessionIdMutation();

  useEffect(() => {
    if (!skip && isOnline && interruptedSession) {
      mutation({ sessionId: interruptedSession, body: { finished: true } })
        .catch(() => window.console.error('Failed to update history'))
        .finally(() => removeItem());
    }
  }, [isOnline, interruptedSession]);
};

